import { CardValidationErrors } from "./validationErrors";
var monthRegEx = /(0[1-9]|1[0-2])/;
export var isValidExpiryDate = function (expiryDate) {
    if (!expiryDate) {
        return { valid: false, error: CardValidationErrors.emptyExpiryDate };
    }
    var rawExpiryDate = expiryDate.replace(' / ', '').replace('/', '');
    if (rawExpiryDate.length === 4) {
        var month = rawExpiryDate.slice(0, 2);
        var year = "20".concat(rawExpiryDate.slice(2, 4));
        if (!monthRegEx.test(month)) {
            return { valid: false, error: CardValidationErrors.monthOutOfRange };
        }
        if (parseInt(year) < new Date().getFullYear()) {
            return { valid: false, error: CardValidationErrors.yearOutOfRange };
        }
        if (parseInt(year) === new Date().getFullYear() && parseInt(month) < new Date().getMonth() + 1) {
            return { valid: false, error: CardValidationErrors.dateOutOfRange };
        }
        return { valid: true, error: "" };
    }
    return { valid: false, error: CardValidationErrors.invalidExpiryDate };
};
